import { Col, Form, Row } from "antd";
import React, { Component } from "react";
import { connect } from "react-redux";
import { ReactComponent as Right } from "../../../static/arrowRight.svg";
import "./institution.scss";
const mapDispatchToProps = (dispatch) => {
  return {};
};
class ConnectedInstitutionEmail extends Component {
  submitForm = async () => {
    await this.props.submit();
    this.props.next();
  };

  render() {
    const formItemLayout = {
      labelCol: {
        xs: {
          span: 24,
        },
        sm: {
          span: 24,
        },
      },
      wrapperCol: {
        xs: {
          span: 24,
        },
        sm: {
          span: 24,
        },
      },
    };
    return (
      <div>
        <div>
          <Form
            ref={this.props.formRef}
            {...formItemLayout}
            name="email"
            onFinish={this.submitForm}
            scrollToFirstError
            layout="vertical"
            //wrapperCol={{ style: { padding: "0", margin: "0 0 0 0" } }}
          >
            <Row>
              <Col span={18} style={{ padding: "1.5em" }}>
                <Form.Item
                  //label={<strong>E-mail:</strong>}
                  name="email"
                  rules={[
                    {
                      required: true,
                      message: "Kérem adja meg a kapcsolattartó e-mail címét!",
                    },
                    {
                      type: "email",
                      message: "Helytelen formátum!",
                    },
                  ]}
                >
                  <input
                    id="email"
                    name="email"
                    onChange={this.props.change}
                    value={this.props.email}
                    onFocus={this.props.setInputName}
                    style={{ width: "100%" }}
                    className="inst-input-field"
                    placeholder="E-mail cím"
                  />
                </Form.Item>
              </Col>
              <Col span={4} style={{ padding: "1.5em" }}>
                <Form.Item>
                  <button type="submit" className="free-next-button">
                    Következő <Right className="free-arrow-icon" />
                  </button>
                </Form.Item>
              </Col>
            </Row>
          </Form>
          {/* <Form
            ref={this.props.formRef}
            {...formItemLayout}
            name="email"
            onFinish={this.submitForm}
            scrollToFirstError
            layout="vertical"
            //wrapperCol={{ style: { padding: "0", margin: "0 0 0 0" } }}
          >
            <Form.Item
              label={<strong>Kapcsolattartó e-mail:</strong>}
              name="email"
              rules={[
                {
                  required: true,
                  message: "Kérem adja meg a kapcsolattartó e-mail címét!",
                },
                {
                  type: "email",
                  message: "Helytelen formátum!",
                },
              ]}
            >
              <Input
                id="email"
                name="email"
                onChange={this.props.change}
                value={this.props.email}
                onFocus={this.props.setInputName}
              />
            </Form.Item>
            <Form.Item>
              <Button
                danger
                onClick={this.props.prev}
                style={{ marginRight: "0.5em" }}
              >
                Vissza
              </Button>
              <Button
                type="primary"
                htmlType="submit"
                danger
                style={{ marginLeft: "0.5em" }}
              >
                Következő
              </Button>
            </Form.Item>
          </Form> */}
        </div>
      </div>
    );
  }
}
const mapStateToProps = (state) => ({});
const InstitutionEmail = connect(
  mapStateToProps,
  mapDispatchToProps
)(ConnectedInstitutionEmail);
export default InstitutionEmail;
